module.exports = __webpack_public_path__ + "img/goin2.7a3842f9.png";